<template>
  <div class="flex justify-center">
    <div
      class="flex h-full flex-auto select-none items-center"
      :class="{ 'opacity-50': disabled }"
    >
      <label class="relative h-full w-full cursor-pointer">
        <input
          :id="id"
          :checked="isChecked"
          :value="value"
          type="checkbox"
          :name="name"
          :disabled="disabled"
          class="peer sr-only"
          @change="updateInput"
        />
        <slot :active="isChecked" />
      </label>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    modelValue: undefined | null | boolean | string | number | Array<any>;
    name?: string;
    value?: string | number | boolean;
    trueValue?: string | number | boolean;
    falseValue?: string | number | boolean;
    id?: string;
    disabled?: boolean;
    readonly?: boolean;
  }>(),
  {
    value: "",
    trueValue: true,
    falseValue: false,
    id: "",
    name: "",
    readonly: false,
  },
);

const emit = defineEmits(["update:modelValue"]);

const isChecked = computed(() => {
  if (props.modelValue instanceof Array) {
    return props.modelValue.includes(props.value);
  }
  return props.modelValue === props.trueValue;
});

function updateInput(event: Event) {
  if (props.readonly) {
    return;
  }
  const isChecked = (event.target as HTMLInputElement).checked;
  if (props.modelValue instanceof Array) {
    const newValue = [...props.modelValue];
    if (isChecked) {
      newValue.push(props.value);
    } else {
      newValue.splice(newValue.indexOf(props.value), 1);
    }
    emit("update:modelValue", newValue);
  } else {
    emit("update:modelValue", isChecked ? props.trueValue : props.falseValue);
  }
}
</script>
